<template>
    <div class="container admin-table-page">
        <!-- Fila del título y flecha hacia atrás -->
        <div class="param-title-wrap niif-header">
            <div class="d-flex align-items-center w-100">
                <div class="d-flex align-items-center">
                    <b-button class="page-back-btn mr-2" variant="link" @click="goBack">
                        <font-awesome-icon :icon="['fas', 'arrow-alt-circle-left']" class="back-icon" />
                    </b-button>
                    <h2 class="param-title">{{ labels.title }}</h2>
                </div>
            </div>
        </div>

        <!-- Fila de filtros debajo del título a la izquierda -->
        <div class="param-title-wrap niif-header">
            <div class="d-flex align-items-center w-100">
                <div class="filters-container d-flex align-items-center">
                    <b-form-select
                        id="report-select"
                        v-model="fecha"
                        class="filter-select"
                    >
                        <b-form-select-option value="">
                            {{ labels.selectReport }}
                        </b-form-select-option>
                        <option v-for="item in lstFechaCausacion" :key="item.id" :value="item.vigencia">
                            {{ item.vigencia }}
                        </option>
                    </b-form-select>                  
                    <b-button
                        class="consult-btn ml-2"
                        @click="consultaSaldos()"
                        :disabled="!fecha"
                    >
                        <font-awesome-icon :icon="['fas', 'search']" class="mr-1" />
                        {{ labels.consultar }}
                    </b-button>
                </div>
            </div>
        </div>

        <div class="admin-table-block mt-4">
            <div v-if="!isLoading">
                <CorporateDataTable
                    :items="lstCausacion"
                    :fields="allFields"
                    :labels="tableLabels"
                    :default-per-page="10"
                    :page-options="[10, 20, 50, 100]"
                    :narrow="false"
                    :table-min-height="500"
                    :table-max-height="500"
                    :show-search="showSearchTable"
                    :allow-column-toggle="true"
                    :enable-sorting="true"
                    :filter-defs="tableFilterDefs"
                    :toolbar-disabled="!showToolbarExtras"
                >
                    <template #toolbar-actions>
                        <div class="niif-toolbar-right">
                            <b-button
                                size="sm"
                                class="table-toolbar-excel-btn"
                                @click="genExcelListadoCausacion()"
                                :disabled="!showToolbarExtras || lstCausacion.length === 0"
                            >
                                <font-awesome-icon :icon="['fas', 'file-excel']" class="mr-1" />
                            </b-button>
                        </div>
                    </template>

                    <template #cell(identificacion)="data">
                        <div class="text-left">{{ proveedor(data.item?.identificacion) }}</div> 
                    </template>
                    <template #cell(saldo_anterior)="data">
                        <div class="text-right">{{ formatNumber(data.item?.saldo_anterior) }}</div> 
                    </template>
                    <template #cell(debito)="data">
                        <div class="text-right">{{ formatNumber(data.item?.debito) }}</div> 
                    </template>
                    <template #cell(credito)="data">
                        <div class="text-right">{{ formatNumber(data.item?.credito) }}</div> 
                    </template>
                    <template #cell(saldo_actual)="data">
                        <div class="text-right">{{ formatNumber(data.item?.saldo_actual) }}</div> 
                    </template>

                </CorporateDataTable>
            </div>

            <!-- Spinner de carga -->
            <div v-if="isLoading" class="text-center py-5">
                <b-spinner></b-spinner>
                <p class="mt-2">{{ labels.loading }}</p>
            </div>
        </div>
    </div>
</template>

<script>
import ContratoSaldos from '../../services/ContratoSaldos'; 
import Authentication from '../../services/Authentication'; 
import Tercero from '../../services/Tercero.js';
import CorporateDataTable from '../utils/CorporateDataTable.vue';
import * as XLSX from "exceljs";

export default {
    name : 'ListadoCausacion',
    components:{CorporateDataTable},
    data : () => ({
        fecha : '',
        btnGenExcel : false,
        loading: false,
        lstFechaCausacion : [],
        lstCausacion : [],
        listTercero : [],
        nameCompania : '',
        isLoading: false,
        showToolbarExtras: false
    }),
    computed:{
        labels(){
            if(this.$store.state._language == "es-ES"){ 
                return {
                    title : 'Listado causación',
                    seleccion : 'Seleccione...', 
                    fecha : 'Fecha:',
                    consultar : 'Consultar',
                    noRow : 'No hay registros.',
                    contrato: 'Contrato', 
                    proveedor: 'Proveedor', 
                    tipoActivo: 'Tipo activo', 
                    cuenta: 'Cuenta',
                    nombre: 'Nombre',
                    centCosto: 'Centro costo',
                    saldoAnt: 'Saldo anterior',
                    debito: 'Débito',
                    credito: 'Crédito',
                    saldoAct: 'Saldo actual',
                    filterContrato : 'Filtrar contrato...',
                    filterNroCuenta : 'Filtrar cuenta...',
                    filterCuenta : 'Filtrar nombre...',
                    filterProveedor : 'Filtrar proveedor...',
                    filterTipActivo: 'Filtrar tipo activo...',
                    filterCentroCost: 'Filtrar centro costo...',
                    filterSaldoAnt: 'Filtrar saldo anterior...',
                    filterDebito: 'Filtrar débito...',
                    filterCredito: 'Filtrar crédito...',
                    filterSaldoAct: 'Filtrar saldo actual...',
                    selectReport : 'Seleccione Fecha', 
                    loading: 'Cargando...',
                    noData: 'No hay datos disponibles',
                    noMatches: 'No se encontraron resultados',
                    searchPlaceholder: 'Buscar en la tabla...',
                    rowsPerPage: 'Filas por página:',
                    noSort: 'Sin orden',
                    sortAsc: 'A-Z / Menor a mayor',
                    sortDesc: 'Z-A / Mayor a menor',
                    columns: 'Columnas',
                    showAllColumns: 'Mostrar todas',
                    filters: 'Filtros',
                    clearFilters: 'Limpiar filtros',

                }
            }else{
                return {
                    title : 'Causation list',
                    seleccion : 'Select...', 
                    fecha : 'Date:',
                    consultar : 'Consult',
                    noRow : 'There are no records.',
                    contrato: 'Contract', 
                    proveedor: 'Provider', 
                    tipoActivo: 'Active type', 
                    cuenta: 'Account',
                    nombre: 'Name',
                    centCosto: 'Cost center',
                    saldoAnt: 'Previous balance',
                    debito: 'Debit',
                    credito: 'Credit',
                    saldoAct: 'Current balance',
                    filterContrato : 'Filter contract...',
                    filterNroCuenta : 'Filter account...',
                    filterCuenta : 'Filter by name...',
                    filterProveedor : 'Filtrar provider...',
                    filterTipActivo: 'Filtrar tipo activo...',
                    filterCentroCost: 'Filter asset type...',
                    filterSaldoAnt: 'Filter previous balance...',
                    filterDebito: 'Filter debit...',
                    filterCredito: 'Filter credit...',
                    filterSaldoAct: 'Filter current balance...',
                    selectReport : 'Select Date',
                    loading: 'Loading...', 
                    noData: 'No data available',
                    noMatches: 'No results found',
                    searchPlaceholder: 'Search in table...',
                    rowsPerPage: 'Rows per page:',
                    noSort: 'No sorting',
                    sortAsc: 'A-Z / Low to high',
                    sortDesc: 'Z-A / High to low',
                    columns: 'Columns',
                    showAllColumns: 'Show all',
                    filters: 'Filters',
                    clearFilters: 'Clear filters',
                }
            }
        },
        allFields() {
            return [
                { key: 'nro_contrato', label: this.labels.contrato, sortable: true, thClass: 'text-center', tdClass: 'text-center align-middle', thStyle: { whiteSpace: 'nowrap', minWidth: '100px' } },
                { key: 'identificacion', label: this.labels.proveedor, sortable: true, thClass: 'text-left', tdClass: 'text-start align-middle', thStyle: { whiteSpace: 'nowrap', minWidth: '200px' } },
                { key: 'tipo_activo', label: this.labels.tipoActivo, sortable: true, thClass: 'text-left', tdClass: 'text-start align-middle', thStyle: { whiteSpace: 'nowrap', minWidth: '150px' } },
                { key: 'cuenta', label: this.labels.cuenta, sortable: true, thClass: 'text-left', tdClass: 'text-left align-middle', thStyle: { whiteSpace: 'nowrap', minWidth: '100px' } } ,
                { key: 'nombre', label: this.labels.nombre, sortable: true, thClass: 'text-left', tdClass: 'text-start align-middle', thStyle: { whiteSpace: 'nowrap', minWidth: '400px' } },
                { key: 'centro_costo', label: this.labels.centCosto, thClass: 'text-center', tdClass: 'text-center align-middle', sortable: false, thStyle: { whiteSpace: 'nowrap', minWidth: '150px' } },
                { key: 'saldo_anterior', label: this.labels.saldoAnt, thClass: 'text-center', tdClass: 'text-end align-middle', sortable: false, thStyle: { whiteSpace: 'nowrap', minWidth: '150px' } },
                { key: 'debito', label: this.labels.debito, thClass: 'text-center', tdClass: 'text-end align-middle', sortable: false, thStyle: { whiteSpace: 'nowrap', minWidth: '150px' } },
                { key: 'credito', label: this.labels.credito, thClass: 'text-center', tdClass: 'text-end align-middle', sortable: false, thStyle: { whiteSpace: 'nowrap', minWidth: '150px' } },
                { key: 'saldo_actual', label: this.labels.saldoAct, thClass: 'text-center', tdClass: 'text-end align-middle', sortable: false, thStyle: { whiteSpace: 'nowrap', minWidth: '150px' } },
            ]
        },
        tableFilterDefs() {
            return [
                { key: 'nro_contrato', type: 'text', placeholder: this.labels.filterContrato },
                { key: 'identificacion', type: 'text', placeholder: this.labels.filterProveedor },
                { key: 'tipo_activo', type: 'text', placeholder: this.labels.filterTipActivo },
                { key: 'cuenta', type: 'text', placeholder: this.labels.filterNroCuenta },
                { key: 'nombre', type: 'text', placeholder: this.labels.filterCuenta },
                { key: 'centro_costo', type: 'text', placeholder: this.labels.filterCentroCost },
                { key: 'saldo_anterior', type: 'text', placeholder: this.labels.filterSaldoAnt },
                { key: 'debito', type: 'text', placeholder: this.labels.filterDebito },
                { key: 'credito', type: 'text', placeholder: this.labels.filterCredito },
                { key: 'saldo_actual', type: 'text', placeholder: this.labels.filterSaldoAct },
            ]
        },
        tableLabels() {
            return {
                noRow: this.labels.noData,
                noMatches: this.labels.noMatches,
                searchPlaceholder: this.labels.searchPlaceholder,
                rowsPerPage: this.labels.rowsPerPage,
                noSort: this.labels.noSort,
                sortAsc: this.labels.sortAsc,
                sortDesc: this.labels.sortDesc,
                columns: this.labels.columns,
                showAllColumns: this.labels.showAllColumns,
                filters: this.labels.filters,
                clearFilters: this.labels.clearFilters
            }
        },
        showSearchTable() {
            return true
        }
    },
    methods:{
        goBack() {
            this.$router.back()
        },
        async consultaSaldos(){

            if (!this.fecha) {
                this.$toast.error('Diligenciar la fecha.');
                return;
            }

            this.isLoading = true;

            try {
                const res = await ContratoSaldos.consultaListadoCausacion(this.fecha)
                this.lstCausacion = res.data.infoCausacion || [];
                
                this.showToolbarExtras = this.lstCausacion.length > 0;

                if (!this.lstCausacion.length) {
                    this.$toast.error("No hay datos para la fecha seleccionada.");
                }
            } catch (err) {
                console.error(err);
                this.$toast.error("Error al consultar los datos.");
            } finally {
                this.isLoading = false;
            }
        },
        async genExcelListadoCausacion(){

            const {Workbook} = XLSX
            const workbook = new Workbook()
            const worksheet = workbook.addWorksheet("Listado causacion "+this.fecha) 

            const titulo = ["Listado causacion - "+this.fecha] 
            worksheet.addRow(titulo) 
            worksheet.mergeCells('A1:J1') 
            worksheet.getCell('A1').font = { name: 'Arial', bold : true, size : 12}; 
            worksheet.getCell('A1').alignment = { horizontal : 'center'}; 

            // =======================
            // FILA 2
            // =======================
            worksheet.addRow(['']); 
            worksheet.mergeCells('A2:J2'); 

            const cell2 = worksheet.getCell('A2'); 

            cell2.value = { 
                richText: [
                    { text: 'Generado por: ', font: { bold: true } },
                    { text: `${this.$store.state.userName} | ` }, 

                    { text: 'Fecha generación: ', font: { bold: true } },
                    { text: `${this.fechaActual()} | ` }, 

                    { text: 'Compañía: ', font: { bold: true } },
                    { text: `${this.nameCompania}` }, 
                ]
            };

            cell2.font = { name: 'Arial', size: 12 }; 
            cell2.alignment = { horizontal: 'center', vertical: 'middle' }; 

            worksheet.addRow(['']); 
            worksheet.mergeCells('A3:J3') 

            // =======================
            // HEADER TABLA
            // =======================
            const headerRow = worksheet.addRow([ 
                'Contrato',
                'Proveedor',
                'Tipo activo',
                'Nro. cuenta', 
                'Cuenta',
                'Centro costo',
                'Saldo anterior',
                'Débito',
                'Crédito',
                'Saldo actual'
            ])

            headerRow.font = { name: 'Arial', size: 11, bold: true } 
            headerRow.alignment = { horizontal: 'center' } 

            // =======================
            // DATA
            // =======================
            this.lstCausacion.forEach(e => { 
                worksheet.addRow([ 
                    e.nro_contrato, 
                    this.proveedor(e.identificacion), 
                    e.tipo_activo, 
                    e.cuenta, 
                    e.nombre, 
                    e.centro_costo, 
                    this.formatNumber(e.saldo_anterior), 
                    this.formatNumber(e.debito), 
                    this.formatNumber(e.credito), 
                    this.formatNumber(e.saldo_actual) 
                ])
            })

            //Poner borde
            const border = {
                top : {style : 'thin'},
                left : {style : 'thin'},
                bottom : {style : 'thin'},
                right : {style : 'thin'},
            }
            
            for( let row = 1; row <= worksheet.rowCount; row++){ 

                if ([1, 2, 3].includes(row)) continue; // 👈 omitir filas 

                for( let col = 1; col <= worksheet.columnCount; col++){ 
                    worksheet.getCell(row, col).border = border; 
                }
            }
            //------

            const file = await workbook.xlsx.writeBuffer() 
            const downloadLink = document.createElement("a") 
            downloadLink.download = "Listado causación "+this.fecha+".xlsx" 
            downloadLink.href = window.URL.createObjectURL( 
                new Blob([file], {
                    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", 
                })
            )

            downloadLink.style.display = "none"; 

            document.body.appendChild(downloadLink); 
            downloadLink.click(); 

            downloadLink.remove(); 
        },
        proveedor(identify){
            if	(identify == null || identify == undefined) {
                return identify
            }
                let nameTercero = this.listTercero.find((tercer) => tercer.identificacion === identify) 

            if	(nameTercero == undefined) {
                return "Sin Nombre "+identify
            }
            return nameTercero?.nombre
        },
        formatNumber(value) {
            return new Intl.NumberFormat('es-CO', { minimumFractionDigits: 0, maximumFractionDigits: 0 })?.format(value); 
        },
        fechaActual(){
            const fecha = new Date()

            const año = fecha.getFullYear() 
            const mes = String(fecha.getMonth() + 1).padStart(2, '0') // getMonth() va de 0 a 11 
            const dia = String(fecha.getDate()).padStart(2, '0') 

            return `${año}-${mes}-${dia}`
        },
    },
    mounted(){

        Tercero.getAllTercero() 
        .then((res) => { 
            this.listTercero = res.data.listTercero 
        })
        .catch((err) => console.log(err))

        ContratoSaldos.getListadoFechas() 
        .then((res) => { 
            // console.log(res.data.lstFechaSaldo); 
            this.lstFechaCausacion = res.data.lstFechaSaldo 
        })
        .catch((err) => console.log(err)) 

        Authentication.leaParametros() 
        .then ((result) => { 
            this.nameCompania = result.data.parametros.compania 
        })
        .catch((err) => console.log(err)) 
    },
    watch:{
        fecha(val){
            if(val == ""){
                this.lstCausacion = [] 
                this.showToolbarExtras = false;
            }
        }
    }
}
</script>

<style scoped>
/* Estilos para el contenedor de filtros - ahora a la izquierda */
.niif-header .filters-container {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-shrink: 0;
    margin-left: 0 !important;
}

.niif-header .filter-select {
    min-width: 200px;
    max-width: 280px;
    width: auto;
    height: 38px;
    font-size: 14px;
    border-radius: 7px;
}

/* Para que el texto de las opciones se vea completo */
.niif-header .filter-select option {
    white-space: normal;
    word-break: break-word;
    padding: 4px 8px;
}

.niif-header .consult-btn {
    height: 38px;
    min-height: 38px;
    padding: 0 20px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    white-space: nowrap;
    border-radius: 7px;
    font-size: 14px;
    background-color: #6c757d !important;
    color: white !important;
    border: 1px solid #6c757d !important;
    cursor: pointer;
    flex-shrink: 0;
}

.niif-header .consult-btn:hover,
.niif-header .consult-btn:focus,
.niif-header .consult-btn:active,
.niif-header .consult-btn:not(:disabled):hover,
.niif-header .consult-btn:not(:disabled):focus,
.niif-header .consult-btn:not(:disabled):active {
    background-color: #6c757d !important;
    color: white !important;
    border-color: #6c757d !important;
    box-shadow: none !important;
}

.niif-header .consult-btn:disabled {
    opacity: 0.65;
    cursor: not-allowed;
    background-color: #6c757d !important;
    color: white !important;
    border-color: #6c757d !important;
}

/* Estilos para la flecha y título */
.page-back-btn {
    padding: 0;
    font-size: 1.5rem;
    line-height: 1;
}

.back-icon {
    font-size: 1.75rem !important;
    width: 1.75rem !important;
    height: 1.75rem !important;
}

.param-title {
    font-size: 2rem !important;
    font-weight: 500;
}

.niif-toolbar-right {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 8px;
    flex: 0 0 auto;
}

.table-toolbar-excel-btn {
    height: 31px;
    min-height: 31px;
    padding: 0 14px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    white-space: nowrap;
    border-radius: 7px;
    font-size: 13px;
    background-color: #016690;
    color: white;
    border: 1px solid #085170;
}

.table-toolbar-excel-btn:hover:not(:disabled) {
    background-color: #085170;
    border-color: #0e3a4d;
}

.table-toolbar-excel-btn:disabled {
    opacity: 0.65;
    cursor: not-allowed;
}

/* Ajustes responsivos */
@media (max-width: 1200px) {
    .niif-header .filter-select {
        min-width: 160px;
        max-width: 220px;
        height: 36px;
        font-size: 13px;
    }

    .niif-header .consult-btn {
        height: 36px;
        min-height: 36px;
        font-size: 13px;
        padding: 0 16px;
    }
}

@media (max-width: 992px) {
    .niif-header .filters-container {
        flex-wrap: wrap;
        width: 100%;
        margin-top: 8px;
        margin-left: 0 !important;
        justify-content: flex-start;
        gap: 6px;
    }

    .niif-header .filter-select {
        min-width: 150px;
        max-width: 200px;
        height: 36px;
        font-size: 13px;
        flex: 1 1 auto;
    }

    .niif-header .consult-btn {
        height: 36px;
        min-height: 36px;
        font-size: 13px;
        padding: 0 16px;
    }
}

@media (max-width: 576px) {
    .param-title {
        font-size: 1.5rem !important;
    }

    .niif-header .filter-select {
        min-width: 100%;
        max-width: 100%;
        height: 36px;
        font-size: 13px;
        flex: 0 0 100%;
    }

    .niif-header .filters-container {
        gap: 4px;
    }

    .niif-header .consult-btn {
        width: 100%;
        flex: 0 0 100%;
        height: 36px;
        margin-left: 0 !important;
        margin-top: 4px;
    }
}
</style>